"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initApolloClient = exports.createApolloClient = void 0;
const isNil_1 = __importDefault(require("lodash/isNil"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const client_1 = require("@apollo/client");
const cache_1 = require("@apollo/client/cache");
const error_1 = require("@apollo/client/link/error");
const context_1 = require("@apollo/client/link/context");
const utilities_1 = require("@apollo/client/utilities");
const subscriptions_1 = require("@apollo/client/link/subscriptions");
const graphql_ws_1 = require("graphql-ws");
let globalApolloClient = null;
const registerWebsocketEvents = (wsClient, listeners) => {
    if (!wsClient)
        return;
    if ((0, isNil_1.default)(listeners) || (0, isEmpty_1.default)(listeners))
        return;
    if (listeners.onPing) {
        wsClient.on("ping", listeners.onPing);
    }
    if (listeners.onPong) {
        wsClient.on("pong", listeners.onPong);
    }
    if (listeners.onError) {
        wsClient.on("error", listeners.onError);
    }
    if (listeners.onOpened) {
        wsClient.on("opened", listeners.onOpened);
    }
    if (listeners.onClosed) {
        wsClient.on("closed", listeners.onClosed);
    }
    if (listeners.onConnected) {
        wsClient.on("connected", listeners.onConnected);
    }
    if (listeners.onConnecting) {
        wsClient.on("connecting", listeners.onConnecting);
    }
    if (listeners.onMessage) {
        wsClient.on("message", listeners.onMessage);
    }
};
function createApolloClient(initialState = {}, options) {
    const { getAuthToken, constructApolloLinks, websocketRequest, cacheConfig, cache: optionCache } = options, restOptions = __rest(options, ["getAuthToken", "constructApolloLinks", "websocketRequest", "cacheConfig", "cache"]);
    const ssrMode = typeof window === "undefined";
    const retrieveAuthToken = (ctx) => __awaiter(this, void 0, void 0, function* () {
        return getAuthToken ? getAuthToken(ctx) : null;
    });
    const authLink = (0, context_1.setContext)((_, context) => __awaiter(this, void 0, void 0, function* () {
        const { headers } = context;
        const token = yield retrieveAuthToken(context);
        const authprops = token ? { authorization: `Bearer ${token}` } : {};
        return {
            headers: Object.assign(Object.assign({}, headers), authprops)
        };
    }));
    const httpLink = new client_1.HttpLink(options.graphqlRequest);
    const onErrorLink = (0, error_1.onError)(({ graphQLErrors, networkError }) => {
        if (graphQLErrors) {
            graphQLErrors.map(({ message, locations, path }) => console.error(`[GraphQL error]: Message: `, message, " Location: ", locations, "Path: ", path));
        }
        if (networkError)
            console.error(`[Network error]: ${networkError}`);
    });
    let link = client_1.ApolloLink.from([onErrorLink, authLink, httpLink]);
    if (constructApolloLinks) {
        link = client_1.ApolloLink.from(constructApolloLinks({ errorLink: onErrorLink, authLink, httpLink }));
    }
    if (!ssrMode && !(0, isNil_1.default)(websocketRequest) && !(0, isEmpty_1.default)(websocketRequest)) {
        const wsClient = (0, graphql_ws_1.createClient)(Object.assign(Object.assign({}, websocketRequest), { url: websocketRequest.url, connectionParams: () => __awaiter(this, void 0, void 0, function* () {
                const authToken = yield retrieveAuthToken();
                return {
                    headers: {
                        authorization: authToken ? `Bearer ${authToken}` : ""
                    }
                };
            }) }));
        registerWebsocketEvents(wsClient, options === null || options === void 0 ? void 0 : options.websocketEvents);
        const wsLink = new subscriptions_1.GraphQLWsLink(wsClient);
        link = client_1.ApolloLink.split(({ query }) => {
            const definition = (0, utilities_1.getMainDefinition)(query);
            return (definition.kind === "OperationDefinition" &&
                definition.operation === "subscription");
        }, wsLink, link);
    }
    const cache = optionCache !== null && optionCache !== void 0 ? optionCache : new cache_1.InMemoryCache(cacheConfig).restore(initialState);
    const client = new client_1.ApolloClient(Object.assign({ ssrMode, connectToDevTools: options.connectToDevTools || false, cache,
        link }, restOptions));
    return client;
}
exports.createApolloClient = createApolloClient;
const initApolloClient = (initialState = null, options) => {
    if (typeof window === "undefined") {
        return createApolloClient(initialState, options);
    }
    if (!globalApolloClient) {
        globalApolloClient = createApolloClient(initialState, options);
    }
    return globalApolloClient;
};
exports.initApolloClient = initApolloClient;
exports.default = {
    createApolloClient,
    initApolloClient: exports.initApolloClient
};
//# sourceMappingURL=index.js.map